import { PasswordField as FormPasswordField } from 'components/Form';
import { PropsOf } from 'types';
import asSettingsFormField from '../asSettingsFormField';

const PasswordField = asSettingsFormField()(FormPasswordField);
type Props = PropsOf<typeof PasswordField>;

export default PasswordField;
export { Props as PasswordFieldProps };
